// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConnectionGuideEdge-guide-layer {
  pointer-events: none;
}

.ConnectionGuideEdge-highlight {
  fill: none;
  stroke: var(--canvas-green-strong, #70a33d);
  stroke-linecap: round;
  stroke-width: 4;
  opacity: 0.36;
  vector-effect: non-scaling-stroke;
}

.ConnectionGuideEdge-particle {
  fill: var(--canvas-green-strong, #70a33d);
  stroke: #fff;
  stroke-width: 2;
  filter: drop-shadow(0 0 3px rgba(112, 163, 61, 0.72));
  pointer-events: none;
  vector-effect: non-scaling-stroke;
}

@media (prefers-reduced-motion: reduce) {
  .ConnectionGuideEdge-particle {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/canvas/edges/ConnectionGuideEdge.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,2CAA2C;EAC3C,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,qDAAqD;EACrD,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".ConnectionGuideEdge-guide-layer {\n  pointer-events: none;\n}\n\n.ConnectionGuideEdge-highlight {\n  fill: none;\n  stroke: var(--canvas-green-strong, #70a33d);\n  stroke-linecap: round;\n  stroke-width: 4;\n  opacity: 0.36;\n  vector-effect: non-scaling-stroke;\n}\n\n.ConnectionGuideEdge-particle {\n  fill: var(--canvas-green-strong, #70a33d);\n  stroke: #fff;\n  stroke-width: 2;\n  filter: drop-shadow(0 0 3px rgba(112, 163, 61, 0.72));\n  pointer-events: none;\n  vector-effect: non-scaling-stroke;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .ConnectionGuideEdge-particle {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
